<template>
  <b-modal
    ref="modal-modeloenviosms"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione o modelo para o envio
    </template>

    <BaseSelectModeloEnvio ref="BaseSelectModeloEnvio" @select="setValueOnData" />

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="onCreateAcao"
      icon="fas fa-check-circle"
      text="Salvar"
    />
  </b-modal>
</template>

<script>
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import BaseSelectModeloEnvio from '@/views/private/configurations/lista-inteligente/components/add/component/BaseSelectModeloEnvio.vue'

const AcaoListaInteligenteData = {
  modeloEnvioId: null,
  acaoListaInteligente: 'SEND_SMS'
}

export default {
  name: 'SendSmsListaInteligenteModal',
  components: {
    DefaultButton,
    BaseSelectModeloEnvio
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      acaoListaId: null
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.$refs['modal-modeloenviosms'].show()
      }
    },
    hideModal () {
      this.$refs['modal-modeloenviosms'].hide()
    },
    setValueOnData (modeloId) {
      this.data.modeloEnvioId = modeloId
    },
    onCreateAcao () {
      if (this.data.modeloEnvioId) {
        loading.push()
        ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
          .then((response) => {
            if (response.status === 201) {
              toast.success(this.$lang.Common.Alerts.Success)
              this.hideModal()
              this.$emit('reloadAcoes')
            }
            loading.close()
          })
          .catch(this.onException)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/SendSmsListaInteligenteModal.vue